module.exports = __webpack_public_path__ + "static/img/repeat.b65d88dd.svg";